// extracted by mini-css-extract-plugin
module.exports = {"sms_icon":"styles_sms_icon__1jbt8","email_icon":"styles_email_icon__r6lLf","tickDone_icon":"styles_tickDone_icon__2IQ9n"};